import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import {
  Badge,
  IconButton,
  Typography,
} from '@mui/material';
import axios from 'axios';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

export default function Notifications() {
  const anchorRef = useRef(null);
  
  // Initialize notifications count
  const [notificationCount, setNotificationCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    handlePayment();
  }, []);

  const handlePayment = async () => {
    try {
      const response = await axios.get('https://form.cpccbe.org/api/payment/payment/pending');
      setNotificationCount(response.data.count); // Set the notification count from the response
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };

  const handleClick = () => {
    navigate('/dashboard/payment');
  };



  return (
    <>
      <IconButton
        ref={anchorRef}
        color={'primary'}
        sx={{ width: 40, height: 40 }}
        onClick={handleClick}
      >
        <Badge badgeContent={notificationCount} color="error" >
          <Iconify icon="eva:bell-fill" width={20} height={20} />
        </Badge>
      </IconButton>

      {/* Optionally display loading text or a message below the button */}
      {loading && (
        <Typography variant="body2" sx={{ marginTop: 1 }}>Loading...</Typography>
      )}
    </>
  );
}
